/* eslint-disable max-len */
import { StatusApplicationCode } from 'const';
import { accentColors } from 'portfolio3/styles';

import { WidgetType } from '../../containers/widgets';

export const getStatusApplicationColor = (statusApplicationCode: number) => {
  switch (statusApplicationCode) {
    case StatusApplicationCode.approved:
    case StatusApplicationCode.registered:
      return accentColors.green[100];
    case StatusApplicationCode.noPlacesAvailable:
    case StatusApplicationCode.applicationsCanceled:
    case StatusApplicationCode.eventCanceled:
    case StatusApplicationCode.canceled:
      return accentColors.red[100];
    case StatusApplicationCode.pending:
      return accentColors.orange[100];
  }

  return null;
};

export const getStatusApplicationTooltip = (statusApplicationCode: number, typeApplication: WidgetType | undefined) => {
  if (statusApplicationCode === StatusApplicationCode.approved) {
    return 'Мероприятие появилось в твоем календаре';
  }
  if (statusApplicationCode === StatusApplicationCode.noPlacesAvailable) {
    return 'Обратись к классному руководителю, он предложит тебе другие даты';
  }
  if (statusApplicationCode === StatusApplicationCode.pending) {
    return 'Срок рассмотрения заявки составляет 1-2 рабочих дня. Когда ответственный от школы зарегистрирует тебя на мероприятие, оно появится в расписании';
  }
  if (statusApplicationCode === StatusApplicationCode.applicationsCanceled) {
    if (typeApplication && [WidgetType.PROBES, WidgetType.EXCURSIONS].includes(typeApplication)) {
      return 'Твоя заявка на участие в мероприятии отменена. Посмотри другие доступные мероприятия и прими участие в одном из них';
    }
    if (typeApplication === WidgetType.OPEN_DAY) {
      return 'Твоя заявка на участие в мероприятии отменена';
    }
  }
  if (statusApplicationCode === StatusApplicationCode.eventCanceled) {
    if (typeApplication && [WidgetType.PROBES, WidgetType.EXCURSIONS].includes(typeApplication)) {
      return 'Мероприятие не состоится. Посмотри другие доступные мероприятия и прими участие в одном из них';
    }
    if (typeApplication === WidgetType.OPEN_DAY) {
      return 'Мероприятие не состоится';
    }
  }

  return null;
};
